import { useCallback } from 'react';
import { getAppleLogin, SNS_AUTH_DATA_KEY } from 'app/libs/snsUtils';
import { setSessionItem } from 'app/libs/storageUtils';
import mobileAppBridge from 'app/libs/MobileAppBridge';
import useSsrUserAgent from 'app/hook/common/useSsrUserAgent';

export default function useAuthApple() {
	const ua = useSsrUserAgent();

	/**
	 * 함수 호출시 아래와 같은 타입으로 파라미터를 전달해야 합니다.
	 * snsAuthorizeForTypes.LOGIN,
	 * snsAuthorizeForTypes.MY_INFO_ACCESS,
	 * snsAuthorizeForTypes.CONNECT_LOGIN
	 */
	const authorizeApple = useCallback(
		async (type, options) => {
			if (!type) throw new Error('인증 타입을 전달해 주세요.');

			if (process.env.REACT_APP_DEPLOY_ENV === 'local') {
				alert('빌드 후 노드서버로 실행 해야 테스트가 가능합니다.');
				return;
			}

			try {
				const state = Date.now().toString();
				setSessionItem(SNS_AUTH_DATA_KEY, { type, state, options });

				if (ua().isApp && ua().isIOS) {
					const result = mobileAppBridge().verifyApple();
					if (result) return;
				}
				const appleAuth = await getAppleLogin();
				await appleAuth.signIn({ state });
			} catch (err) {
				console.error(err);
			}
		},
		[ua],
	);

	return { authorizeApple };
}
